<template>
    <card class="d-flex flex-column" plain>
        <div class="d-flex" style="gap: 5px;">
            <b-badge v-if="address.isPrimary" variant="primary">Is Primary</b-badge>
            <b-badge variant="info">{{ PatientAddressType[address.type] }}</b-badge>
            <b-badge :variant="address.isValidated ? 'success' : 'secondary'">
                {{ address.isValidated ? 'Validated' : 'Not Validated' }}
            </b-badge>
        </div>
        <div>
            {{ address.address1 }}
        </div>
        <div>
            {{ address.address2 }}
        </div>
        <div>
            {{ address.city }}
            {{ address.state }}
            {{ address.postalCode }}
        </div>
        <div v-if="!hideActions" class="d-flex mt-1" style="gap: 10px;">
            <a href="" @click.prevent="$emit('edit')">
                <b-icon icon="pencil-square" />
                Edit
            </a>
            <a href="" @click.prevent="$emit('delete')" class="text-danger">
                <b-icon icon="trash" />
                Delete
            </a>
        </div>
    </card>
</template>

<script lang="ts">
import { PatientAddress, PatientAddressType } from '@/models/Patient';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: "PatientAddressCard",
    components: {

    },
})
export default class PatientAddressCard extends Vue {

    @Prop({ required: true }) private address!: PatientAddress;
    @Prop({ default: false }) private hideActions!: boolean;

    PatientAddressType = PatientAddressType;

}
</script>
